import { setInvitation } from '../actions';
import { AppAction, StateApp } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof StateApp> = Reducer<StateApp, AppAction, T>;

const invitation: ReducerOf<'invitation'> = (state = null, action: AppAction) => {
  switch (action.type) {
    case setInvitation.type:
      return action.payload;

    default:
      return state;
  }
};


export default invitation;
